import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import Card from '../UI/Card';
import FormField from '../UI/FormField';
import { IProduct } from '@/interfaces/product.interface';
import React, { useEffect, useState } from 'react';
import ErrorMessage from '@/components/common/ErrorMessage';
import { errorTypes } from '@/utility/validation';

interface ProductDiscountProps {
  register: UseFormRegister<IProduct>;
  watch: UseFormWatch<IProduct>;
  setValue: UseFormSetValue<IProduct>;
  control: Control<IProduct>;
  error: FieldErrors<IProduct>
}

const ProductDiscount: React.FC<ProductDiscountProps> = ({
  register,
  watch,
  setValue,
  control,
  error
}) => {
  const prefix = 'productInfo.0.';
  const discountStartDate = watch(`${prefix}discountStartDate`);
  const discountEndDate = watch(`${prefix}discountEndDate`);
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [dateError, setDateError] = useState<string | null>(null);

  useEffect(() => {
    if (!discountStartDate || !discountEndDate) {
      setDateError(null);
      return;
    }

    const start = new Date(discountStartDate);
    const end = new Date(discountEndDate);

    if (end < start) {
      setDateError('End date cannot be earlier than start date.');
    } else if (end.getTime() === start.getTime()) {
      setDateError('Start date and end date cannot be the same.');
    } else {
      setDateError(null);
    }
  }, [discountStartDate, discountEndDate]);

  useEffect(() => {
    const hasDiscount = [
      discountStartDate,
      discountEndDate,
    ].some((val) => !!val);

    setDiscountEnabled(hasDiscount);
  }, [discountStartDate, discountEndDate]);


  return (
    <>
      {/* Discount */}
      <Card>
        <h2 className="text-lg font-semibold mb-6">Discount</h2>
        <FormField
          label="Add Product Discount"
          type="checkbox"
          checked={discountEnabled}
          onChange={(e) => {
            const checked = (e.target as HTMLInputElement).checked;
            setDiscountEnabled(checked);
            if (!checked) {
              setValue(`${prefix}discountPercentage`, 0);
            }
          }}
        />
      </Card>
      {discountEnabled && (
        <>
          {/* Discount Code */}
          {/* <Card>
                            <div className="flex flex-col sm:flex-row gap-5 sm:items-end">
                                <FormField
                                    label="Discount Code"
                                    type="text"
                                    placeholder="Enter discount code"
                                    {...register(`${prefix}discountCode`)}
                                />
                                <button
                                    type="button"
                                    className="p-3 rounded-2xl bg-blue-300 text-primary">
                                    Generate code automatically
                                </button>
                            </div>
                            <p className="text-xs text-gray-500 mt-2">
                                Customer has to enter this coupon at checkout
                            </p>
                        </Card> */}

          {/* Discount Value & Eligibility */}
          <div className="grid grid-cols-1  gap-6 mb-6">
            {/* Discount Value */}
            <Card>
              <div className="space-y-6">
                <h2 className="text-lg font-semibold">Discount Value</h2>
                <div>
                  <FormField
                    label="Label"
                    placeholder="EID Special"
                    min={0}
                    {...register(`${prefix}discountLabel`, {
                      ...errorTypes.required('Discount Label')
                    })}
                  />
                  <ErrorMessage message={error?.productInfo && error?.productInfo?.[0]?.discountLabel?.message} />
                </div>
                {/* Discount Type + Value */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
                  <FormField label="Discount Type" value={'percentage'} />
                  <div>
                    <FormField
                      label="Value"
                      type="number"
                      placeholder="20"
                      suffix="%"
                      min={0}
                      {...register(`${prefix}discountPercentage`, {
                        valueAsNumber: true,
                        ...errorTypes.required('Discount value')
                      })}
                    />
                    <ErrorMessage message={error?.productInfo && error?.productInfo?.[0]?.discountPercentage?.message} />
                  </div>
                </div>
                {/* <div className="space-y-4">
                                        Specific Collection
                                        <FormField
                                            label="Collection"
                                            type="select"
                                            options={['Specific Collection']}
                                        />

                                        Search Collection
                                        <FormField type="text" placeholder="Search Collection" />
                                    </div> */}
              </div>
            </Card>

            {/* Eligibility */}
            {/* <Card>
                                <div className="space-y-4">
                                    <h2 className="text-lg font-semibold mb-6">Eligibility</h2>
                                    <div className="space-y-2">
                                        <FormField
                                            type="radio"
                                            name="eligibility"
                                            label="All Customers"
                                        />
                                        <FormField
                                            type="radio"
                                            name="eligibility"
                                            label="Specific customer segment"
                                            defaultChecked
                                        />
                                        <FormField
                                            type="radio"
                                            name="eligibility"
                                            label="Specific customer"
                                        />
                                    </div>
                                    <FormField type="text" placeholder="Search Customer Segment" />
                                </div>
                            </Card> */}
          </div>

          {/* Minimum Requirement & Max Uses */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            Minimum Purchase Requirement
                            <Card>
                                <h2 className="text-lg font-semibold mb-4">
                                    Minimum Purchase Requirement
                                </h2>
                                <div className="space-y-3">
                                    Option 1
                                    <FormField
                                        type="radio"
                                        name="requirement"
                                        label="No minimum requirement"
                                        defaultChecked
                                    />

                                    Option 2 with input
                                    <div className="space-y-2">
                                        <FormField
                                            type="radio"
                                            name="requirement"
                                            label="Minimum purchase amount (BD)"
                                            defaultChecked={true}
                                        />
                                        <FormField type="number" placeholder="Enter Amount" />
                                    </div>

                                    Option 3 with input
                                    <div className="space-y-2">
                                        <FormField
                                            type="radio"
                                            name="requirement"
                                            label="Minimum quantity of products"
                                        />
                                        <FormField type="number" placeholder="Enter Min Quantity" />
                                    </div>
                                </div>
                            </Card>

                            Maximum Discount Uses
                            <Card>
                                <h2 className="text-lg font-semibold mb-4">
                                    Maximum Discount Uses
                                </h2>
                                <div className="space-y-3">
                                    Radio 1
                                    <FormField type="radio" name="uses" label="Single use" />

                                    Radio 2
                                    <FormField
                                        type="radio"
                                        name="uses"
                                        label="Multiple use"
                                        defaultChecked
                                    />

                                    Input with number
                                    <FormField type="number" placeholder="Enter number" />
                                </div>
                            </Card>
                        </div> */}

          {/* Active Dates */}
          <Card>
            <div className="space-y-6">
              <h2 className="text-lg font-semibold mb-4">Active dates</h2>
              <Controller
                name={`${prefix}discountStartDate`}
                control={control}
                render={({ field }) => (
                  <div className="grid grid-cols-2 gap-2">
                    <FormField
                      label="Start Date"
                      type="date"
                      value={field.value ? field.value.split('T')[0] : ''}
                      onChange={(e) => {
                        const timePart = field.value?.split('T')[1] || '00:00';
                        field.onChange(`${e.target.value}T${timePart}`);
                      }}
                      required
                      className="w-full border border-light-40 rounded-2xl px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary h-[42px]"
                    />
                    <FormField
                      label="Start Time"
                      type="time"
                      value={
                        field.value ? field.value.split('T')[1].slice(0, 5) : ''
                      }
                      onChange={(e) => {
                        const datePart =
                          field.value?.split('T')[0] ||
                          new Date().toISOString().split('T')[0];
                        field.onChange(`${datePart}T${e.target.value}`);
                      }}
                      className="w-full border border-light-40 rounded-2xl px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary h-[42px]"
                    />
                  </div>
                )}
              />
              <Controller
                name={`${prefix}discountEndDate`}
                control={control}
                render={({ field }) => (
                  <>
                    <FormField
                      type="checkbox"
                      label="Set end date"
                      checked={!!field.value}
                      onChange={(e) => {
                        const isChecked = (e.target as HTMLInputElement)
                          .checked;
                        if (isChecked) {
                          // Default to today with time 00:00
                          const today = new Date().toISOString().split('T')[0];
                          field.onChange(`${today}T00:00`);
                        } else {
                          field.onChange(null);
                        }
                      }}
                    />
                    {field.value && (
                      <div className="grid grid-cols-2 gap-2 mt-2">
                        {/* Date */}
                        <FormField
                          label="End Date"
                          type="date"
                          value={field.value ? field.value.split('T')[0] : ''}
                          onChange={(e) => {
                            const timePart =
                              field.value?.split('T')[1] || '00:00';
                            field.onChange(`${e.target.value}T${timePart}`);
                          }}
                          className="w-full border border-light-40 rounded-2xl px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary h-[42px]"
                        />

                        {/* Time */}
                        <FormField
                          label="End Time"
                          type="time"
                          value={field.value ? field.value.split('T')[1] : ''}
                          onChange={(e) => {
                            const datePart =
                              field.value?.split('T')[0] ||
                              new Date().toISOString().split('T')[0];
                            field.onChange(`${datePart}T${e.target.value}`);
                          }}
                          className="w-full border border-light-40 rounded-2xl px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary h-[42px]"
                        />
                      </div>
                    )}
                  </>
                )}
              />
              <ErrorMessage message={dateError as string} />
            </div>
          </Card>
        </>
      )}
    </>
  );
};

export default ProductDiscount;
